/**
 * Bereken kW uit specs (kW direct of via A/V/cosφ)
 * Gebruikt in zowel UI (preview) als edge function (simulatie)
 */

interface MachineSpec {
  kw?: number;
  amps?: number;
  pf?: number;      // cosφ
  phases?: 1 | 3;
  voltage?: number;
}

export function computeKW(spec: MachineSpec): number {
  // Direct kW opgegeven
  if (spec.kw != null && spec.kw > 0) {
    return spec.kw;
  }

  // Bereken via Ampère
  if (!spec.amps || spec.amps <= 0) {
    throw new Error('Geen kW of Ampère opgegeven');
  }

  // Defaults
  const pf = spec.pf ?? 0.9;
  const phases = spec.phases ?? 3;
  const voltage = spec.voltage ?? (phases === 3 ? 400 : 230);

  // Validatie
  if (pf < 0.5 || pf > 1.0) {
    throw new Error('Power factor moet tussen 0.5 en 1.0 zijn');
  }
  if (phases !== 1 && phases !== 3) {
    throw new Error('Phases moet 1 of 3 zijn');
  }

  // Berekening
  let kw: number;
  if (phases === 3) {
    // 3-fase: P = √3 × V_LL × I × cosφ
    kw = Math.sqrt(3) * voltage * spec.amps * pf / 1000;
  } else {
    // 1-fase: P = V × I × cosφ
    kw = voltage * spec.amps * pf / 1000;
  }

  return Math.round(kw * 100) / 100; // Rond op 0.01 kW
}

export function validateMachineSpec(spec: MachineSpec): string | null {
  // Moet kW of Amps hebben
  if (!spec.kw && !spec.amps) {
    return 'Vul kW of Ampère in';
  }

  // Valideer cosφ
  if (spec.pf != null && (spec.pf < 0.5 || spec.pf > 1.0)) {
    return 'Power factor moet tussen 0.5 en 1.0 zijn';
  }

  // Valideer phases
  if (spec.phases != null && spec.phases !== 1 && spec.phases !== 3) {
    return 'Aantal fasen moet 1 of 3 zijn';
  }

  return null; // Valid
}
